const DELIMITER = '\t';

export function decomposeProjectAccessId(projectAccessId: string): {
  projectId: string;
  teamId: string | null;
  driveId: string | null;
  folderId: string | null;
} {
  const ids = projectAccessId.split(DELIMITER);

  let driveId: string | null = null;
  let folderId: string | null = null;

  if (ids.length === 4) {
    if (ids[3].startsWith('F_')) {
      folderId = ids[3].slice(2);
    } else if (ids[3].startsWith('D_')) {
      driveId = ids[3].slice(2);
    }
  }

  return {
    projectId: ids[0],
    teamId: ids.length >= 3 ? ids[2] : null,
    driveId,
    folderId,
  };
}

export function composeProjectAccessId(inputs: {
  projectId: string;
  userId: string;
  teamId: string | null;
  driveId: string | null;
  folderId: string | null;
}): string {
  const { projectId, userId, teamId, driveId, folderId } = inputs;

  if (folderId)
    return `${projectId}${DELIMITER}${userId}${DELIMITER}${teamId}${DELIMITER}F_${folderId}`;
  if (driveId)
    return `${projectId}${DELIMITER}${userId}${DELIMITER}${teamId}${DELIMITER}D_${driveId}`;
  if (teamId) return `${projectId}${DELIMITER}${userId}${DELIMITER}${teamId}`;
  return `${projectId}${DELIMITER}${userId}`;
}
